import { SET_SNACKBAR } from "@State/actions";
import { SET_CHECKBOX_DATA } from "@State/actions/actionTypes";

const MAX_VISIBLE = 4;

const initialState = {
  notifications: [],
  checkboxes: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SNACKBAR: {
      const payload = action.payload || {};

      // Закрытие конкретного уведомления по ключу.
      if (payload.remove != null) {
        return {
          ...state,
          notifications: state.notifications.filter((n) => n.key !== payload.remove),
        };
      }

      // Внешние диспатчи присылают open: true, чтобы показать уведомление.
      // Старый «закрывающий» вызов (open: false) теперь игнорируем —
      // закрытие идёт через payload.remove из компонента.
      if (payload.open === false) {
        return state;
      }

      const note = {
        key: payload.key ?? `snb-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
        message: payload.message ?? "",
        description: payload.description ?? "",
        severity: payload.severity ?? "info",
      };

      // Добавляем в стопку, ограничивая длину (новые вытесняют самые старые).
      return {
        ...state,
        notifications: [...state.notifications, note].slice(-MAX_VISIBLE),
      };
    }
    case SET_CHECKBOX_DATA:
      return {
        ...state,
        checkboxes: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
